import { isBundleProductTypeName } from "~/utils/constants";

/*
	A structure product must never go through a plain `InsertBasketItem`:
	measured on staging, it materialises the whole structure AND completes any
	structure line already in the basket, overwriting earlier picks. The PDP
	uses `InsertBasketItemWithChildren`.
*/

/** Enough of a Norce product type to name it. */
export interface ProductTypeRef {
	Id: number;
	Name?: string | null;
}

/**
 * `undefined` = cannot tell (a Meilisearch record has no `Type`, and the type
 * list may be unloaded). Callers must resolve it, never read it as "no".
 */
export const isStructureProduct = (
	product: { Type?: number | null } | null | undefined,
	productTypes: ProductTypeRef[] | null | undefined
): boolean | undefined => {
	const typeId = product?.Type;
	if (typeId == null) return undefined;

	const name = productTypes?.find((type) => type.Id === typeId)?.Name;
	return name ? isBundleProductTypeName(name) : undefined;
};
